export async function showKitUsedWarning(warningEl, { alreadyUsed, selectedId, selectedNumber, url }) {
  if (!warningEl) return;

  if (!alreadyUsed) {
    warningEl.classList.add("d-none");
    warningEl.innerHTML = "";
    return;
  }

  warningEl.innerHTML = "Loading kit usage info&hellip;";
  warningEl.classList.remove("d-none");

  try {
    const fetchUrl = new URL(url, window.location.origin);
    fetchUrl.searchParams.set("registered_kit_id", selectedId);
    const response = await fetch(fetchUrl.toString(), { headers: { "Accept": "application/json" } });

    if (response.ok) {
      const data = await response.json();
      const rows = [
        ["Warning", "This kit has already been used in another visit."],
        ["Subject", data.subject_identifier || "Unknown"],
        ["Kit", data.kit_name || selectedNumber],
        ["Date used", data.date_used || "Unknown"],
        ["Visit", data.visit_name || "Unknown"],
      ];
      warningEl.replaceChildren();
      rows.forEach(([label, value], index) => {
        const strong = document.createElement("strong");
        strong.textContent = `${label}: `;
        warningEl.appendChild(strong);
        warningEl.appendChild(document.createTextNode(String(value)));
        if (index < rows.length - 1) warningEl.appendChild(document.createElement("br"));
      });
    } else {
      warningEl.textContent = "Warning: This kit has already been used in another visit.";
    }
  } catch {
    warningEl.textContent = "Warning: This kit has already been used in another visit.";
  }
}
